<template>
  <div class="model-tree position-absolute">
    <el-card :body-style="{ height: checkStatus ? 'calc(100% - 35px)' : '100%' }">
      <el-row :gutter="10" class="m-b-10">
        <el-col :span="12">
          <span class="fz-14">模型选择</span>
        </el-col>
        <el-col :span="12" class="tr">
          <el-switch
            v-if="multiple"
            :disabled="disabled"
            v-model="checkStatus"
            active-text="多选"
            inactive-text="单选"
            active-color="#409eff"
            inactive-color="#c0c4cc"
            @change="changeSwitchStatus"
          ></el-switch>
        </el-col>
      </el-row>
      <div class="height-38 p-b-5">
        <el-input
          size="small"
          placeholder="请输入要过滤的设备"
          v-model="filterTreeKeyWords"
          @keypress.native.enter="filterModelTree(0, true, filterTreeKeyWords, 0)"
          clearable
        >
          <el-button
            slot="append"
            icon="el-icon-arrow-down"
            class="p-l-10 p-r-10"
            @click="filterModelTree(currentNodeItem, true, filterTreeKeyWords, 0)"
          ></el-button>
          <el-button
            slot="append"
            icon="el-icon-arrow-up"
            class="p-l-10 p-r-10"
            @click="filterModelTree(currentNodeItem, false, filterTreeKeyWords, 0)"
          ></el-button>
        </el-input>
      </div>
      <el-tree
        :props="treeProps"
        ref="modelTree"
        :load="loadNode"
        highlight-current
        :lazy="true"
        show-checkbox
        :data="treeData"
        :filter-node-method="filterNode"
        :default-checked-keys="defaultCheckedKeys"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="clickModelTree"
        @check="checkModelTree"
        node-key="item"
      ></el-tree>
      <div class="card-footer position-absolute" v-if="checkStatus">
        <el-button size="mini" @click="clearModelCheck" :disabled="disabled">清 空</el-button>
        <el-button type="primary" size="mini" @click="confirmChecked" :disabled="disabled"
          >确 认</el-button
        >
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'modelCheckTree',
  props: {
    currentNodeItemF: {
      type: Number,
      default: 0,
    },
    player: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiSelectedItems: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 是否支持多选
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    async currentNodeItemF(val) {
      if (val && !this.disabled) {
        this.currentNodeItem = val
        const itemInfo = await window.player.Native.ModelTree.getItemInfo(val)
        this.currentNodeName = itemInfo.name
        this.filterModelTree(0, true, itemInfo.name, 3)
        if (!this.checkStatus) {
          this.$refs.modelTree.setCheckedKeys([])
          this.defaultCheckedKeys = [val]
        }
        if (!this.checkStatus) {
          const itemData = await window.player.Native.ModelTree.getItemInfo(val)
          console.log(itemData)
          this.$emit('setCheckedNode', [itemData])
        }
      }
    },
    disabled(val) {
      if (!val && this.checkStatus) {
        this.$nextTick(() => {
          const checkedNode = _.uniqBy([...this.checkedNodes, ...this.boxMultiSelectItems], 'item')
          _.forEach(checkedNode, (node) => {
            window.player.Native.ModelTree.setItemSelectState(node.item, false)
            window.player.Native.ModelTree.setItemSelectState(node.item, true)
          })
        })
      }
    },
  },
  async mounted() {
    this.treeData = await window.player.Native.ModelTree.getRootItems()
    if (this.currentNodeItemF) {
      const itemInfo = await window.player.Native.ModelTree.getItemInfo(this.currentNodeItemF)
      this.currentNodeName = itemInfo.name
      this.filterModelTree(0, true, itemInfo.name, 3)
      this.defaultCheckedKeys = [this.currentNodeItemF]
    }
    window.player.Native.Tools.setCurrentTool('system.Pickup')
    // 设置云渲染那边的模型颜色高亮效果
    window.player.Native.Settings.set('pickUp.highlight', 'bool', false)
    // 设置云渲染那边的模型包围盒选中效果
    window.player.Native.Settings.set('show.select.box', 'bool', true)
  },
  beforeDestroy() {
    // 设置云渲染那边的模型颜色高亮效果
    window.player.Native.Settings.set('pickUp.highlight', 'bool', true)
    // 设置云渲染那边的模型包围盒选中效果
    window.player.Native.Settings.set('show.select.box', 'bool', false)
    window.player.Native.ModelTree.EventMultiSelectItem.disconnect(this.browseLClick)
    window.player.Native.ModelTree.EventBoxMultiSelectItem.disconnect(this.boxMultiSelect)
    window.player.Native.Tools.setCurrentTool('system.Browse')
  },
  data() {
    return {
      modelTreeVisbile: true, // 模型树的显示
      filterTreeKeyWords: '', // 过滤模型树关键字
      defaultExpandedKeys: [], // 展开节点
      defaultCheckedKeys: [], // 选中节点
      currentNodeItem: 0, // 当前激活的node
      treeData: [],
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
        disabled: () => {
          return this.disabled
        },
      },
      currentNode: null, // 查询到模型树节点
      currentNodeName: '', // 点选时当前激活的节点名称
      checkStatus: false,
      checkedNodes: [], // 选中模型节点
      boxMultiSelectItems: [], // 框选中的模型节点
    }
  },
  methods: {
    // 模型树点击操作
    clickModelTree(data) {
      if (!this.checkStatus) {
        window.player.Native.ModelTree.setSelectItemNoEvent(data.item)
      }
      window.player.Native.Camera.moveToItem(data.item, 2)
      this.locationNode(data.item)
    },
    // 模型树加载
    async loadNode(node, resolve) {
      if (node.level === 0) {
        resolve(this.treeData)
        return
      }
      const res = await PlayerUtils.call(window.player.Native.ModelTree.getSubItems, node.data.item)
      const filterRes = _.filter(res, (el) => {
        return el.name && el.visible
      })
      const checkedKeys = _.map(
        _.filter(filterRes, (el) => {
          return node.checked && el.checked
        }),
        'item'
      )
      this.defaultCheckedKeys.push(...checkedKeys)
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNode && this.currentNode.item) {
          if (el.item === this.currentNode.item) {
            this.locationNode(this.currentNode.item)
          }
        }
      })
    },
    // 定位模型节点
    locationNode(id) {
      this.$nextTick(() => {
        this.$refs.modelTree.setCurrentKey(id)
        setTimeout(() => {
          const node = document.getElementsByClassName('el-tree')[0]
          const currentNode = document.getElementsByClassName('is-current')[0]
          node.scrollTo({
            top: currentNode.offsetTop,
          })
        }, 400)
      })
    },
    // 切换选择模式
    changeSwitchStatus(val) {
      this.$emit('multiItems', val)
      this.clearModelCheck()
      // 设置云渲染那边的模型颜色高亮效果
      window.player.Native.Settings.set('pickUp.highlight', 'bool', val)
      // 设置云渲染那边的模型包围盒选中效果
      window.player.Native.Settings.set('show.select.box', 'bool', !val)
      if (this.checkStatus) {
        window.player.Native.ModelTree.EventMultiSelectItem.connect(this.browseLClick)
        window.player.Native.ModelTree.EventBoxMultiSelectItem.connect(this.boxMultiSelect)
      } else {
        window.player.Native.ModelTree.EventMultiSelectItem.disconnect(this.browseLClick)
        window.player.Native.ModelTree.EventBoxMultiSelectItem.disconnect(this.boxMultiSelect)
      }
    },
    // 点击选中模型取消选中
    async browseLClick(info) {
      const items = await window.player.Native.ModelTree.getMultiSelectedItems()
      let currentInfo = _.cloneDeep(info)
      while (currentInfo.visible === 0) {
        // eslint-disable-next-line no-await-in-loop
        currentInfo = await window.player.Native.ModelTree.getItemInfo(currentInfo.parentItem)
      }
      if (_.findIndex(this.checkedNodes, ['item', currentInfo.item]) !== -1) {
        this.checkedNodes.splice(_.findIndex(this.checkedNodes, ['item', currentInfo.item]), 1)
      } else {
        this.checkedNodes.push(currentInfo)
      }
      const modelItem = currentInfo.item
      this.defaultCheckedKeys = _.uniq([...this.defaultCheckedKeys, modelItem])
      if (_.findIndex(items, ['item', info.item]) !== -1) {
        return
      }
      _.remove(this.boxMultiSelectItems, (item) => {
        return item.item === info.item
      })
      if (_.isEmpty(items)) {
        this.$refs.modelTree.setCheckedKeys([])
        this.defaultCheckedKeys = []
        this.checkedNodes = []
      } else {
        const checkedKeys = this.$refs.modelTree.getCheckedKeys()
        if (checkedKeys.indexOf(modelItem) !== -1) {
          this.$refs.modelTree.setCheckedKeys([])
          this.defaultCheckedKeys = []
          checkedKeys.splice(checkedKeys.indexOf(modelItem), 1)
          let modelInfo = await window.player.Native.ModelTree.getItemInfo(modelItem)
          if (modelInfo.selfId) {
            while (modelInfo.selfId !== 1) {
              // eslint-disable-next-line no-await-in-loop
              modelInfo = await window.player.Native.ModelTree.getItemInfo(modelInfo.parentItem)
              if (checkedKeys.indexOf(modelInfo.item) !== -1) {
                checkedKeys.splice(checkedKeys.indexOf(modelInfo.item), 1)
              }
            }
          }
          this.defaultCheckedKeys = checkedKeys
        } else {
          this.defaultCheckedKeys = _.uniq([...this.defaultCheckedKeys, modelItem])
        }
      }
    },
    // 框选事件
    boxMultiSelect(items) {
      this.$nextTick(() => {
        if (!_.isEmpty(items)) {
          this.$refs.modelTree.setCheckedKeys([])
          this.boxMultiSelectItems = items
          this.defaultCheckedKeys = []
          this.checkedNodes = []
          this.filterModelTree(0, true, items[0].name, 3)
          const filterMulti = _.map(items, (el) => {
            return el.visible ? el.item : el.parentItem
          })
          this.defaultCheckedKeys = filterMulti
        }
      })
    },
    // 清空模型选中
    clearModelCheck() {
      this.$refs.modelTree.setCheckedKeys([])
      this.defaultCheckedKeys = []
      this.checkedNodes = []
      this.boxMultiSelectItems = []
      window.player.Native.ModelTree.setSelectItemNoEvent(0)
    },
    // 确认选中
    async confirmChecked() {
      const checkedNode = await window.player.Native.ModelTree.getMultiSelectedItems()
      this.checkedNodes = checkedNode
      this.$emit('setCheckedNode', checkedNode)
    },
    // 选中模型节点
    checkModelTree(data, node) {
      if (node.checkedKeys.indexOf(data.item) !== -1) {
        window.player.Native.ModelTree.setItemSelectState(data.item, false)
        window.player.Native.ModelTree.setItemSelectState(data.item, true)
        window.player.Native.Camera.moveToItem(data.item, 2)
        this.checkedNodes.push(data)
      } else if (this.checkStatus) {
        window.player.Native.ModelTree.setItemSelectState(data.item, true)
        window.player.Native.ModelTree.setItemSelectState(data.item, false)
        if (_.findIndex(this.checkedNodes, ['item', data.item]) !== -1) {
          this.checkedNodes.splice(_.findIndex(this.checkedNodes, ['item', data.item]), 1)
        }
      }
      if (!this.checkStatus) {
        // 节点选中状态发生变化
        this.$refs.modelTree.setCheckedKeys([])
        this.defaultCheckedKeys = []
        this.$refs.modelTree.setCheckedNodes([data])
        this.$emit('setCheckedNode', [data])
      }
    },
    // 过滤模型树
    async filterModelTree(startItem, direction, KeyWords, type) {
      this.currentNode = await PlayerUtils.call(
        window.player.Native.ModelTree.findItemByName,
        KeyWords, // 关键字
        startItem, // 开始查询的树节点
        direction, // 遍历方向
        type // 0:模糊搜索,3:精确查找
      )
      // 展开树
      if (!_.isEmpty(this.currentNode)) {
        await this.expendNode(this.currentNode)
      } else {
        // 未找到
        this.$message.error('搜索结果到底了')
      }
    },
    // 展开节点树
    async expendNode(node) {
      // item: 1为pr模型跟， node.parentItem = 0为杆塔模型的跟
      if (node.item === 1 || node.parentItem === 0) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          if (!this.currentNodeName) {
            // 无激活节点时
            this.clickModelTree(this.currentNode, { checked: node.checked })
            this.currentNodeItem = this.currentNode.item // 储存选中节点的item
          }
          // 有选中激活节点时
          this.currentNodeName = ''
          this.locationNode(this.currentNode.item)
        })
      } else {
        const res = await PlayerUtils.call(
          window.player.Native.ModelTree.getItemInfo,
          node.parentItem
        )
        await this.expendNode(res)
        this.defaultExpandedKeys.push(res.item)
      }
    },
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
  },
}
</script>

<style lang="scss" scoped>

.model-tree {
  height: 500px;
  width: 450px;
  border-radius: 4px;
  z-index: 999;
  border: none;
  top: 45px;
  left: 0;
  /deep/.el-tree {
    height: calc(100% - 72px);
    overflow-y: auto;
  }
}
/deep/.el-card {
  height: calc(100% - 24px) !important;
  &__body {
    padding: 10px !important;
    border-radius: 2px;
  }
}
.card-footer {
  border: none !important;
  bottom: 34px;
  right: 10px;
}

</style>
